/* eslint-disable eqeqeq */
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Loader } from 'semantic-ui-react';
import { AvForm } from 'availity-reactstrap-validation';
import { NotificationManager } from 'react-notifications';

import { SurveyReview } from '../../../../components';
import { getPageDisable } from '../../../../utils';
import { UserTextService } from '../../../../services';

import {
  findIndex,
  isEmpty,
  cloneDeep,
  map,
  isNumber,
  omit,
} from '../../../../utils/lodash';

import '../activity.scss';

class EvaluationSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      btnLoading: false,
      results: {
        id: props.evaluation.objectiveId,
        result1: 1,
        result2: Boolean(props.evaluation.cumulative) ? 1 : 0,
      },
      form: {},
    };
  }

  componentDidMount() {
    this.setState(
      {
        loading: true,
      },
      async () => {
        const { getEvalReasons, getEvalAssesmentTypes, evaluation } =
          this.props;
        const { selfAssessmentReason = '', actualParticipantsEvaluated = '' } =
          evaluation;
        try {
          await getEvalReasons();
          await getEvalAssesmentTypes();
          const responces = this.getResponse(evaluation.participantResponse);
          this.setState(
            {
              results: {
                id: evaluation.objectiveId,
                result1: responces.one,
                result2: Boolean(evaluation.cumulative) ? responces.two : 0,
              },
              form: {
                [`${evaluation.objectiveId}_Reason`]: selfAssessmentReason,
                actualParticipantsEvaluated,
                assessmentTypes: isEmpty(evaluation.assessmentTypes)
                  ? []
                  : map(evaluation.assessmentTypes, (data) => {
                      return data.id;
                    }),
              },
            },
            () => {
              this.surveyForm && this.surveyForm.reset();
              this.setState({ loading: false });
            }
          );
        } catch (error) {
          this.setState({ loading: false });
        }
      }
    );
  }

  updateResults(results) {
    this.setState({
      results,
    });
  }

  getResponse(participantResponse) {
    let responces = cloneDeep(participantResponse);
    let data = {
      one: 1,
      two: 1,
    };
    if (!isEmpty(responces[0])) {
      let getIndex = findIndex(responces[0], (o) => {
        return o == 1;
      });
      data.one = getIndex + 1;
    }
    if (!isEmpty(responces[1])) {
      let getIndex = findIndex(responces[1], (o) => {
        return o == 1;
      });
      data.two = getIndex + 1;
    }
    return data;
  }

  setResponses(participantResponse, results) {
    let responces = cloneDeep(participantResponse);
    if (!isEmpty(responces[0])) {
      if (isNumber(results.result1)) {
        responces[0] = map(responces[0], (value, i) => {
          if (i === results.result1 - 1) {
            return 1;
          }
          return 0;
        });
      }
    }
    if (!isEmpty(responces[1])) {
      if (isNumber(results.result2)) {
        responces[1] = map(responces[1], (value, i) => {
          if (i === results.result2 - 1) {
            return 1;
          }
          return 0;
        });
      }
    }
    return responces;
  }

  handleValidSubmit = async (event, errors, values) => {
    const { results } = this.state;

    const {
      t,
      updateSelfAssessed,
      evalPlanManage,
      currentActivity,
      evalPlan,
      evaluation,
      extra: { evalAssesmentTypes = [] },
    } = this.props;

    try {
      if (isEmpty(errors)) {
        results.selfAssessmentReason = values[`${results.id}_Reason`] || '';
        results.participantResponse = await this.setResponses(
          evaluation.participantResponse,
          results
        );
        results.actualParticipantsEvaluated =
          Number(values.actualParticipantsEvaluated) || 0;

        results.methodReason = values.methodReason;

        let selectedAssessmentTypes = [];

        if (!isEmpty(results.assessmentTypes)) {
          for (const item of evalAssesmentTypes) {
            if (results.assessmentTypes.includes(item.id)) {
              selectedAssessmentTypes.push(item);
            }
          }

          results.assessmentTypes = selectedAssessmentTypes;
        }

        this.setState(
          {
            btnLoading: true,
          },
          async () => {
            await updateSelfAssessed(
              'activityEvaluation',
              evaluation,
              omit(results, ['id', 'result1', 'result2']),
              true
            );
            this.setState(
              {
                form: {
                  [`${evaluation.objectiveId}_Reason`]:
                    results.selfAssessmentReason,
                  actualParticipantsEvaluated:
                    results.actualParticipantsEvaluated,
                  assessmentTypes: isEmpty(evaluation.assessmentTypes)
                    ? []
                    : map(evaluation.assessmentTypes, (data) => {
                        return data.id;
                      }),
                },
              },
              () => {
                const responces = this.getResponse(results.participantResponse);
                this.setState(
                  {
                    loading: true,
                    btnLoading: false,
                    results: {
                      id: evaluation.objectiveId,
                      result1: responces.one,
                      result2: Boolean(evaluation.cumulative)
                        ? responces.two
                        : 0,
                    },
                  },
                  () => {
                    this.surveyForm && this.surveyForm.reset();
                    this.setState({
                      loading: false,
                    });
                  }
                );
              }
            );
            const form = {
              isSeries: evalPlan.seriesParentId ? true : false,
              dateMeasured: new Date(),
              isSelfAssessed: true,
            };
            await evalPlanManage(
              currentActivity.id,
              evalPlan.id,
              form,
              evalPlan.name
            );
          }
        );
      } else {
        let errorList = [];
        for (const error of errors) {
          switch (error) {
            case 'assessmentTypes':
              errorList.push(
                t('activity.evaluation_plan.error_messages.assessment_basis')
              );
              break;
            case 'actualParticipantsEvaluated':
              errorList.push(
                t(
                  'activity.evaluation_plan.error_messages.number_of_participants_considered'
                )
              );
              break;
            case 'methodReason':
              errorList.push(
                t(
                  'activity.evaluation_plan.error_messages.reason_for_evaluation_method'
                )
              );
              break;
            case `${evaluation.objectiveId}_Reason`:
              errorList.push(
                t(
                  'activity.evaluation_plan.error_messages.reason_for_evaluation_rating'
                )
              );
              break;
            default:
              errorList.push(t('common.something_went_wrong'));
              break;
          }
        }

        NotificationManager.error(
          errorList
            .join(', ')
            .replace(/, ([^,]*)$/, ` ${t('common.and').toLowerCase()} $1`),
          t('error_messages.please_fill_fields')
        );
      }
    } catch (error) {
      NotificationManager.error(t('error_messages.something_went_wrong'));
      this.setState({
        btnLoading: false,
        loading: false,
        results: {
          id: evaluation.objectiveId,
          result1: 1,
          result2: Boolean(evaluation.cumulative) ? 1 : 0,
        },
      });
    }
  };

  render() {
    const {
      t,
      evaluation,
      extra: { evalReasons = [], evalAssesmentTypes = [] },
      currentActivity,
      user,
      currentState,
    } = this.props;

    const setEval = {
      question: {
        heading: evaluation.heading
          ? UserTextService.removeEditableText(evaluation.heading)
          : '',
        methodHeading: evaluation.methodHeading
          ? UserTextService.removeEditableText(evaluation.methodHeading)
          : '',
        question1: evaluation.question1
          ? UserTextService.removeEditableText(evaluation.question1)
          : '',
        question2: evaluation.question2
          ? UserTextService.removeEditableText(evaluation.question2)
          : '',
      },
      objectiveId: evaluation.objectiveId,
      outcome: evaluation.outcome,
      method: evaluation.method,
      cumulative: evaluation.cumulative,
    };
    const { loading, results, btnLoading, form } = this.state;

    const pageDisabled = getPageDisable(currentActivity, user, currentState);

    return (
      <div>
        {loading ? (
          <div className="eval-survey-loading-container">
            <Loader active inline />
          </div>
        ) : (
          <AvForm
            ref={(c) => (this.surveyForm = c)}
            onSubmit={this.handleValidSubmit}
            model={form}
          >
            <SurveyReview
              evalView={{ evalReasons, evalAssesmentTypes }}
              updateResults={(data) => this.updateResults(data)}
              ratingData={results}
              data={evaluation}
              {...setEval}
              pageDisabled={pageDisabled}
            />

            <Button
              loading={btnLoading}
              type="submit"
              className="ui customColor-custom button custom-margin"
              disabled={
                this.props.currentActivity.statusId == 3 || pageDisabled
                  ? true
                  : false || btnLoading
              }
            >
              {t('actions.save')}
            </Button>
          </AvForm>
        )}
      </div>
    );
  }
}

EvaluationSurvey = withTranslation()(EvaluationSurvey);

export { EvaluationSurvey };
